var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2'),_c('v-row',[_c('v-col',{attrs:{"lg":"10","md":"12","xs":"12"}},[_c('app-personal',{attrs:{"customer":_vm.customer}}),_c('div',{staticClass:"text-left"},[_c('v-btn',{staticClass:"mx-2",attrs:{"small":"","exact":"","to":{ name: 'customer-list' }}},[_vm._v(" Back ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }